import React, { useState } from "react";

type TextUnitProps = {
  id: string | number,
  object: {
    x: number,
    y: number,
    width: number,
    height: number,
    transcription: string,
  },
};

const TextUnit: React.FC<TextUnitProps> = ({ object, id }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="absolute box-border border border-red-500 border-1 bg-red-500/10 z-10"
      style={{
        left: `${object.x}px`,
        top: `${object.y}px`,
        width: `${object.width}px`,
        height: `${object.height}px`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && (
        <div
          className="absolute bottom-full left-1/2 mb-px -translate-x-1/2 z-[100]
                               bg-white border border-black border-1 rounded-xs px-0.5 shadow-md
                               whitespace-nowrap"
        >
          <p className="text-[10px]">{object.transcription}</p>
        </div>
      )}
    </div>
  );
};

export default TextUnit;
